卫星遥感正射影像产品
<template>
  <div class="main-div">
    <ul class="main1">
      <li v-for="(item,index) in advantageList" :key="index" class="main1_li">
        <div class="main1_r">
          <h2 class="main1-h2">{{item.title}}</h2>
          <br />
          <p class="text_desc">{{item.desc}}</p>
        </div>
        <!-- <img class="main1_img" :src="item.leftImg" alt /> -->
      </li>
    </ul>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <!-- 标准景正射影像产品 -->
      <el-tab-pane label="标准景正射影像产品" name="first">
        <div class="main2">
          <h2 class="main1-h2">1.标准景正射影像产品</h2>
          <br />
          <p
            class="text_desc"
          >标准景正射影像产品是正射影像的表现形式之一，是卫星影像通过严格几何纠正后得到的影像产品，按整景全色影像和整景多光谱影像分别提供，包含标准景正射影像元数据和影像数据文件，影像数据文件采用image格式存储。</p>
          <div class="mian2_img">
            <el-image
              v-for="(item,index) in chpOneImg"
              :src="item.img"
              fit="contain"
              class="chpOneImg"
              :key="index"
            ></el-image>
          </div>
        </div>
      </el-tab-pane>
      <!-- 区域正射影像产品 -->
      <el-tab-pane label="区域正射影像产品" name="second">
        <div class="main3">
          <h2 class="main1-h2">2.区域正射影像产品</h2>
          <br />
          <p
            class="text_desc"
          >区域正射影像产品是利用整景正射影像产品，通过影像融合、镶嵌、色彩增强等处理，并按指定行政区划单元进行裁切的影像产品，目前已形成了2米分辨率全国一张图产品、16米分辨率全国一张图产品、30米分辨率全国一张图产品、30米分辨率全球一张图产品，并支持按需定制生产</p>
          <!-- 2米 -->
          <div class="meters">
            <el-card :body-style="{ padding: '0px' }">
              <div class="quyuOne">
                <el-image fit="contain" :src="quyu01.leftImg" class="image" />
                <div class="quyuOne_r">
                  <h2 class="quyuOne_h2">{{quyu01.title}}</h2>
                  <p class="quyuOne_desc">{{quyu01.desc}}</p>
                </div>
              </div>
            </el-card>
            <!-- 参数/优势/样例 -->
            <div class="quyuOne">
              <div class="quyuOne_1">
                <p style="font-size: 18px;">产品技术参数</p>
                <ul>
                  <li v-for="(item,index) in quyu01.data" :key="index">
                    <span class="quyuOne_label">{{item.label}}</span>:
                    <span>{{item.value}}</span>
                  </li>
                </ul>
              </div>
              <div class="quyuOne_1">
                <p style="font-size: 18px;">样例数据展示</p>
                <el-image fit="contain" src="../../../../static/officeImg/index/yangli01.webp" alt />
              </div>
            </div>
          </div>
          <!-- 16米 -->
          <div class="meters">
            <el-card :body-style="{ padding: '0px' }">
              <div class="quyuOne">
                <el-image fit="contain" :src=" quyu02.leftImg" class="image" />
                <div class="quyuOne_r">
                  <h2 class="quyuOne_h2">{{ quyu02.title}}</h2>
                  <p class="quyuOne_desc">{{ quyu02.desc}}</p>
                </div>
              </div>
            </el-card>
            <!-- 参数/优势/样例 -->
            <div class="quyuOne">
              <div class="quyuOne_1">
                <p style="font-size: 18px;">产品技术参数</p>
                <ul>
                  <li v-for="(item,index) in  quyu02.data" :key="index">
                    <span class="quyuOne_label">{{item.label}}</span>:
                    <span>{{item.value}}</span>
                  </li>
                </ul>
              </div>
              <div class="quyuOne_1">
                <p style="font-size: 18px;">样例数据展示</p>
                <el-image fit="contain" src="../../../../static/officeImg/index/yangli02.webp" alt />
              </div>
            </div>
          </div>
          <!-- 30米 -->
          <div class="meters">
            <el-card :body-style="{ padding: '0px' }">
              <div class="quyuOne">
                <el-image fit="contain" :src="  quyu03.leftImg" class="image" />
                <div class="quyuOne_r">
                  <h2 class="quyuOne_h2">{{ quyu03.title}}</h2>
                  <p class="quyuOne_desc">{{ quyu03.desc}}</p>
                </div>
              </div>
            </el-card>
            <!-- 参数/优势/样例 -->
            <div class="quyuOne">
              <div class="quyuOne_1">
                <p style="font-size: 18px;">产品技术参数</p>
                <ul>
                  <li v-for="(item,index) in quyu03.data" :key="index">
                    <span class="quyuOne_label">{{item.label}}</span>:
                    <span>{{item.value}}</span>
                  </li>
                </ul>
              </div>
              <!-- <div class="quyuOne_1">
                <p style="font-size: 18px;">样例数据展示</p>
                <img src="../../../../static/officeImg/index/yangli01.png" alt />
              </div>-->
            </div>
          </div>
          <!-- 亚米 -->
          <div class="meters">
            <el-card :body-style="{ padding: '0px' }">
              <div class="quyuOne">
                <el-image fit="contain" :src="quyu04.leftImg" class="image" />
                <div class="quyuOne_r">
                  <h2 class="quyuOne_h2">{{ quyu04.title}}</h2>
                  <p class="quyuOne_desc">{{ quyu04.desc}}</p>
                </div>
              </div>
            </el-card>
            <!-- 参数/优势/样例 -->
            <div class="quyuOne">
              <div class="quyuOne_1">
                <p style="font-size: 18px;">样例数据展示1</p>
                <el-image fit="contain" src="../../../../static/officeImg/index/yangli04.webp" alt />
              </div>
              <div class="quyuOne_1">
                <p style="font-size: 18px;">样例数据展示2</p>
                <el-image
                  fit="contain"
                  src="../../../../static/officeImg/index/yangli04_2.webp"
                  alt
                />
              </div>
            </div>
          </div>
          <!-- 获取方式 -->
          <p class="quyuOne_h2 access">数据获取方式</p>
          <el-table :data="tableData" stripe style="width: 100%">
            <el-table-column prop="date" label="项目"></el-table-column>
            <el-table-column prop="name" label="交易方式"></el-table-column>
            <el-table-column prop="address" label="生产周期"></el-table-column>
            <el-table-column prop="phone" label="购买渠道"></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 产品 -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: "first",
      //产品介绍
      advantageList: [
        {
          leftImg: require("../../../../static/officeImg/index/solution1.png"),
          title: "产品介绍",
          desc: "卫星遥感正射影像产品是以Landsat系列、高分系列、资源系列等多源、多尺度的卫星影像为数据源生产的正射影像产品，该产品分为标准景正射影像产品、区域正射影像产品、分幅正射影像产品三种形式。正射影像产品具有精度高、信息丰富、直观逼真、获取快捷等优点，能够进行良好的判读和量测，可直接利用于自然资源调查、公共设施建设规划、自然灾害分析等多种领域。",
        },
      ],
      //标准产品
      chpOneImg: [
        { img: require("../../../../static/officeImg/index/biaozhun_1.png") },
        { img: require("../../../../static/officeImg/index/biaozhun_2.png") },
      ],
      //区域产品
      quyu01: {
        leftImg: require("../../../../static/officeImg/index/2_1.png"),
        title: "2米分辨率全国一张图产品",
        desc: "2米分辨率全国一张图产品是当前分辨率最高的覆盖全国的真彩色正射影像产品，该产品可按省界、市界、县界和地区级行政区划单元提供，成果采用非压缩的标准 TIFF 格式存储，可为政府部门、各行业、GIS用户等提供遥感底图服务，是各行业进行遥感解译与信息提取的理想选择。",
        data: [
          {
            label: "采用的数据源",
            value: "GF1/BCD/GF6/ZY3系列",
          },
          {
            label: "定位精度",
            value: "采用公开参考，RMSE10-20米",
          },
          {
            label: "坐标系",
            value: "Albers等面积投影，可按需定制",
          },
          {
            label: "更新频次",
            value: "年度动态更新",
          },
          {
            label: "已有产品",
            value: "2015年、2018年、2019年、2020年、2021年、2022年",
          },
        ],
      },
      quyu02: {
        leftImg: require("../../../../static/officeImg/index/16_1.png"),
        title: "16米分辨率全国一张图产品",
        desc: "基于高分一号、高分六号宽幅传感器数据，经过正射、融合、匀色、镶嵌等处理生成了16米分辨率全国一张图，可以实现年度动态更新。",
        data: [
          {
            label: "采用的数据源",
            value: "GF1/GF6",
          },
          {
            label: "定位精度",
            value: "采用公开参考，匹配精度2-4个像元",
          },
          {
            label: "坐标系",
            value: "Albers等面积投影，可按需定制",
          },
          {
            label: "更新频次",
            value: "年度动态更新",
          },
          {
            label: "已有产品",
            value: "2015年、2018年、2020年",
          },
        ],
      },
      quyu03: {
        leftImg: require("../../../../static/officeImg/index/30_1.png"),
        title: "30米分辨率全球一张图",
        desc: "利用Landsat高精度正射影像数据,经过半自动的数据挑选、快速自动化镶嵌和匀色等关键技术，制作色彩一致性较高的30米分辨率全球一张图。30米分辨率全球一张图几何精度高、色彩一致性好,可为遥感应用、虚拟现实等提供基础底图。",
        data: [
          {
            label: "采用的数据源",
            value: "Landsat数据",
          },
          {
            label: "定位精度",
            value: "采用公开参考，匹配精度2-4个像元",
          },
          {
            label: "坐标系",
            value: "WGS 84经纬度",
          },
          {
            label: "更新频次",
            value: "按需更新",
          },
        ],
      },
      quyu04: {
        leftImg: require("../../../../static/officeImg/index/yami_1.png"),
        title: "亚米分辨率正射影像产品定制服务",
        desc: "支持国产高分2、7号亚米分辨率卫星数据正射影像产品的定制服务。",
        data: [
          {
            label: "采用的数据源",
            value: "GF1/BCD/GF6/ZY3系列",
          },
          {
            label: "定位精度",
            value: "采用公开参考，RMSE10-20米",
          },
          {
            label: "坐标系",
            value: "Albers等面积投影，可按需定制",
          },
          {
            label: "更新频次",
            value: "年度动态更新",
          },
          {
            label: "已有产品",
            value: "2015年、2018年、2019年、2020年、2021年、2022年",
          },
        ],
      },
      //表格
      tableData: [
        {
          date: "高清影像",
          name: "存档，或按项目区域定制",
          address: "存档数据5个工作日内交付",
          phone: "采购电话：18610570353（葛经理）",
        },
      ],
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
  },
};
</script>
<style scoped >
::-webkit-scrollbar {
  width: 4px;
}
::-webkit-scrollbar-track {
  /* background-color: darkgrey; */
  background-color: white;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.6);
  border-radius: 4px;
}
li {
  list-style: none;
}
.main-div {
  width: 70%;
  height: 1500px;
  margin: 0 auto;
  margin-top: 40px;
}
.main1 {
  height: auto;
  margin-bottom: 20px;
}
.main1_li {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.main1_r {
  width: 100%;
  height: 90%;
  text-align: left;
  padding: 10px;
}
.text_desc {
  font-size: 18px;
  letter-spacing: 5px;
  text-indent: 38px;
  text-align: left;
}
.main1-h2 {
  font-size: 22px;
  font-weight: 600;
  color: #1c72dc;
  text-align: center;
}
.main1_img {
  width: 30%;
  height: 100%;
}
/* 二级 */
.main2 {
  margin: 20px 0 80px;
}
/* 标准 */
.mian2_img {
  width: 100%;
  height: 500px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 20px 0;
}
.chpOneImg {
  display: block;
  width: 600px;
  height: 100%;
}
/* 区域 */
.main3 {
  height: 800px;
  overflow: auto;
  margin-top: 20px;
}
.quyuOne {
  width: 100%;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.image {
  display: block;
  width: 40%;
  height: 300px;
}
.quyuOne_r {
  width: 55%;
}
.quyuOne_h2 {
  font-size: 20px;
  font-weight: normal;
  margin: 15px;
  color: #1c72dc;
}
.access {
  margin: 0px;
  text-align: left;
}
.quyuOne_desc {
  font-size: 16px;
  text-indent: 38px;
  text-align: left;
}
.quyuOne_1 {
  width: 47%;
  text-align: left;
  font-size: 14px;
  padding: 10px;
}
.quyuOne_1 ul {
  width: 100%;
  height: 200px;
  margin-top: 10px;
}
.quyuOne_1 li {
  height: 30px;
  line-height: 30px;
}
.quyuOne_1 img {
  width: 100%;
  height: 220px;
}
.quyuOne_label {
  width: 200px;
  color: red;
}
/* 2米 */
.meters {
  margin-top: 40px;
  margin-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/remoteDigData/components/silhouette.vue